import { jsx as _jsx } from "react/jsx-runtime";
import { staticTableCellDecorator, ModelTypeWithDescription, } from 'Shared/components';
export const createTypeWithDescription = staticTableCellDecorator((type, row) => (_jsx(ModelTypeWithDescription, { type: type, description: row.type.description || '' }, void 0)));
